let counter = 0

export const getUID = () => {
  counter += 1

  return counter
}
